export const validateMothersMaidenName = mothersMaidenName => {
  if (!mothersMaidenName) {
    return "Please enter your mother's maiden name.";
  }

  if (mothersMaidenName.length > 80) {
    return "Please enter your mother's maiden name.";
  }

  if (/[^a-zA-Z '-]/gi.test(mothersMaidenName)) {
    return "Please only enter letters, spaces, single quote or hyphen for mother's maiden name.";
  }

  return false;
};

export const validateMonthlyRent = monthlyRent => {
  if (!monthlyRent) {
    return 'Please enter your monthly rent or mortgage payment.';
  }

  if (monthlyRent.length > 4) {
    return 'Please check that your monthly payment is correct.';
  }
  return false;
};

export const validateTotalAnnualIncome = totalAnnualIncome => {
  if (!totalAnnualIncome || totalAnnualIncome === '') {
    return 'Please enter your monthly rent or mortgage payment.';
  }

  if (totalAnnualIncome.length < 5) {
    return 'Please check that your total annual income is correct.';
  }
  return false;
};

export const validateTotalBalanceOfAccounts = totalBalanceOfAccounts => {
  if (!totalBalanceOfAccounts || totalBalanceOfAccounts === '') {
    return 'Please select your total accounts balance';
  }

  return false;
};

export const validateEmploymentStatus = employmentStatus => {
  if (!employmentStatus || employmentStatus === '') {
    return 'Please select your employment status.';
  }

  return false;
};

export const validateResidence = residence => {
  if (!residence || residence === '') {
    return 'Please select your housing status.';
  }

  return false;
};

export const validateBankAccountType = bankAccountType => {
  if (!bankAccountType || bankAccountType === '') {
    return 'Please select your bank account type.';
  }

  return false;
};

export const validateIfOffered = isOffered => {
  if (!isOffered || isOffered === '') {
    return 'Please select if you would be interested in blank checks.';
  }

  return false;
};

export const validateIsUsCitizen = isUsCitizen => {
  if (isUsCitizen === '') {
    return 'Please select your citizenship status.';
  }

  return false;
};

export const validateCountry = country => {
  if (!country || country === '') {
    return 'Please select your country of citizenship.';
  }

  return false;
};
